<template>
    <div class="container">

      <div class="video" ref="video">
        <ExpanderVideo :filename="videoFiles[0][0]" :autoplay="true" :url="videoFiles[0][1]" :name="videoFiles[0][2]" :mutedOnStart="true" />
      </div>

      <div class="image">
        <img src="@/assets/keyart.png">
      </div>

      <div class="heading">Else hyller sine favoritter</div>

      <div class="thumbs" :class="{leftmost: leftMost, rightmost: rightMost}" ref="container">
        <div class="scroll" @scroll="scrollerScrolled" ref="scroller">
          <div class="items" ref="items">
            <button @click="openVideo(1)" class="item" :class="{active: current == 1}">
              <img src="@/assets/thumbs/1.png">
              <div class="info">
                <strong class="title">
                  LEO AJKIC
                </strong>
              </div>
            </button>
            <button @click="openVideo(2)" class="item" :class="{active: current == 2}">
              <img src="@/assets/thumbs/2.png">
              <div class="info">
                <strong class="title">
                  PIA TJELTA
                </strong>
              </div>
            </button>
            <button @click="openVideo(3)" class="item" :class="{active: current == 3}">
              <img src="@/assets/thumbs/3.png">
              <div class="info">
                <strong class="title">
                  HENRIETTE STEENSRUP
                </strong>
              </div>
            </button>
          </div>
        </div>
        <!-- <button class="nav prev" @click="scrollToPrev"><img src="@/assets/arr-l.svg"></button>
        <button class="nav next" @click="scrollToNext"><img src="@/assets/arr-r.svg"></button> -->
      </div>
    </div>

    <div class="modal" v-if="openedVideo !== null">
      <DiscoveryVideoModal :item="videoFiles[openedVideo]" @closeModal="closeVideo()" />
    </div>
</template>

<script>
import ExpanderVideo from './ExpanderVideo.vue'
import DiscoveryVideoModal from './DiscoveryVideoModal.vue';
  
  export default {
    name: 'DiscoveryVideos',
    components: {
      ExpanderVideo,
      DiscoveryVideoModal,
    },
    data() {
      return {
        videoFile: 'trailer.mp4',
        current: 0,
        leftMost: true,
        rightMost: false,
        openedVideo: null,
        videoFiles: [
          [
            'main.mp4',
            'https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1',
            'Trailer'
          ],
          [
            '1.mp4',
            'https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1',
            'Leo Ajkic',
          ],
          [
            '2.mp4',
            'https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1',
            'Pia Tjelta',
          ],
          [
            '3.mp4',
            'https://ad.doubleclick.net/ddm/trackclk/N7914.2537101SHOWHEROES/B33052824.413369579;dc_trk_aid=605628111;dc_trk_cid=229040560;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=;dc_tdv=1',
            'Henriette Steensrup',
          ],
        ]
      }
    }, 
    methods: {
      openVideo(id) {
        this.openedVideo = id
      },
      closeVideo() {
        this.openedVideo = null
      },
      scrollToPrev: function() {
        let w = this.$refs.items.children[0].offsetWidth
        this.$refs.scroller.scrollBy({left: w * -1, behavior: 'smooth'})
      },
      scrollToNext: function() {
        let w = this.$refs.items.children[0].offsetWidth
        this.$refs.scroller.scrollBy({left: w, behavior: 'smooth'})
      },
      scrollerScrolled: function() {
        this.leftMost = (this.$refs.scroller.scrollLeft < 50)
        this.rightMost = (this.$refs.scroller.scrollLeft > this.$refs.items.offsetWidth - this.$refs.container.offsetWidth - 50)
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '@/scss/variables.scss';
  @import '@/scss/mixins.scss';

  .container {
    padding: 0 0 2.5rem;
    @include d {
      padding: 0 2.5rem 2.75rem;
    }
  }

  .video {
    position: relative;
    z-index: 1;
    margin: 0 1.5rem;
    border-radius: .625rem;
    border: .1875rem solid #BC9C64;
    overflow: hidden;
    @include d {
      margin: 0;
      border-width: .3125rem;
    }
  }

  .image {
    position: absolute;
    right: 0;
    top: 32.5rem;
    z-index: 2;
    width: 58vw;
    pointer-events: none;
    @include d {
      top: 47.5rem;
      width: 30rem;
    }
  }

  .heading {
    position: relative;
    z-index: 2;
    margin: 6rem 0 1.75rem;
    font-size: 1.5rem;
    text-align: center;
    text-shadow: .3125rem .25rem .3312rem rgba(0, 0, 0, 0.53);
    @include d {
      margin: 10.375rem 0 1.75rem;
      font-size: 2.25rem;
    }
  }

  .thumbs {
    position: relative;
    z-index: 3;
    margin-top: 1.25rem;
    .scroll {
      @include m {
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-snap-type: x mandatory;
      }
    }
    .scroll::-webkit-scrollbar {
      display: none;
    }
    .items {
      display: flex;
      justify-content: space-between;
      @include m {
        display: inline-flex;
        padding: 0 1.5rem;
        button + button {
          margin-left: 2rem;
        }
      }
    }
    .item {
      position: relative;
      width: 19.375rem;
      border-radius: 0.625rem;
      border: .3125rem solid #BC9C64;
      overflow: hidden;
      @include m {
        width: 70vw;
        scroll-snap-align: center;
        border-width: .1875rem;
      }
      &::after {
        content: '';
        @include cover;
        background: url('@/assets/play.png') no-repeat center 38% / 3.75rem auto;
        transition: .3s;
      }
      img {
        transition: .4s
      }
      .info {
        @include cover;
        display: flex;
        display: none;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 4.5rem;
        background: rgba(0, 0, 0, 0.40);
        color: #fff;
        transition: .2s ease-out;
        .caption {
          display: block;
          font-size: 1.125rem;
          font-style: normal;
          line-height: 1;
          letter-spacing: -0.03375rem;
        }
        .title {
          font-size: 1.25rem;
          font-weight: normal;
          text-transform: uppercase;
          line-height: 1;
        }
      }
      &:hover {
        img {
          transform: scale(1.1);
        }
        .info {
          background: rgba(0, 0, 0, 0.20);
        }
      }
      &.active {
        &::after {
          display: none;
        }
        .info {
          background: rgba(0, 0, 0, 0);
        }
      }
    }
  }

  .nav {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    &.prev {
      left: 1rem;
    }
    &.next {
      right: 1rem;
    }
    @include d {
      display: none;
    }
  }
  .leftmost {
    .prev {
      display: none;
    }
  }
  .rightmost {
    .next {
      display: none;
    }
  }

</style>
